import { IGif } from '@giphy/js-types'
import React, { useContext, useState } from 'react'
import { webFetch } from 'shared/api'
import ClickAndScrollCarousel from 'shared/components/click-and-scroll-carousel'
import ArtistBlocks from 'shared/components/content-blocks/artists'
import SearchBlocks from 'shared/components/content-blocks/popular-searches'
import ReactionBlocks from 'shared/components/content-blocks/reactions'
import GifContext from 'shared/components/context/gif'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import styled from 'styled-components'

const Container = styled.div`
    padding-bottom: 40px;
`

const PopularSearches = styled(SearchBlocks)`
    margin-bottom: 60px;
`

const Artists = styled(ArtistBlocks)`
    margin-bottom: 60px;
`

const Reactions = styled(ReactionBlocks)`
    margin-bottom: 60px;
`

const HomepageContentBlocks = () => {
    const [gifs, setGifs] = useState<IGif[]>()
    const { receivedGifs } = useContext(GifContext)
    useAsyncEffect(async () => {
        const { data: gifs } = await webFetch.trending({ type: 'stickers' })
        receivedGifs({ gifs })
        setGifs(gifs)
    }, [])
    return (
        <Container>
            <PopularSearches width={1040} />
            <Reactions width={1040} />
            <Artists width={1040} />
            {gifs && (
                <ClickAndScrollCarousel
                    gifs={gifs}
                    title={`Trending Stickers`}
                    path={`/stickers`}
                    height={140}
                    styles={{ margin: `25px 0 50px` }}
                    onClick={() => {
                        googleAnalyticsEvent({
                            category: 'Homepage',
                            action: 'Click',
                            label: 'Trending Stickers Carousel',
                        })
                    }}
                />
            )}
        </Container>
    )
}

export default HomepageContentBlocks
